import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, SmartphoneIcon } from 'lucide-react';
export function PricingCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Fire AddToCart via fbq
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Primeros Auxilios Emocionales',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
      console.log('[Meta Pixel] AddToCart event fired');
    } else {
      console.warn('[Meta Pixel] fbq not available');
    }
    // Fallback: fire AddToCart via image pixel
    const img = new Image();
    img.src = `https://www.facebook.com/tr?id=1460768755599404&ev=AddToCart&cd[content_name]=Primeros+Auxilios+Emocionales&cd[content_type]=product&cd[value]=6.39&cd[currency]=USD&noscript=1`;
    setTimeout(() => {
      window.open('https://shopcoremethod.com/cart/45996396085445:1', '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <section ref={ref} id="precio" className="w-full bg-[#FFFAF5] px-4 py-16 md:py-24" data-id="element-115">
      <div className="max-w-2xl mx-auto" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] leading-tight mb-4" data-id="element-118">
            ¡Recupera la paz de tu hogar hoy!
          </h2>
          <p className="text-lg text-[#5C4A3A] mb-8 max-w-xl mx-auto" data-id="element-119">
            Obtén el sistema completo de Primeros Auxilios Emocionales por una
            inversión mínima de lanzamiento.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl p-8 md:p-10 shadow-lg shadow-[#3D2B1F]/8 border border-[#E8A838]/20 text-center relative overflow-hidden" data-id="element-120">
          {/* Urgency Badge */}
          <div className="flex justify-center mb-6" data-id="element-121">
            <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold bg-[#E8A838] text-white shadow-sm" data-id="element-122">
              <ZapIcon className="w-4 h-4" aria-hidden="true" data-id="element-123" />
              Oferta Especial por Tiempo Limitado
            </span>
          </div>

          {/* Product Image Small */}
          <div className="flex justify-center mb-6" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/3UXDKYDiqBkdhLr3WHBiE1/portada_2.png" alt="Manual de Primeros Auxilios Emocionales" className="w-48 md:w-56 rounded-xl shadow-md shadow-[#3D2B1F]/10" data-id="element-125" />
          </div>

          {/* Price */}
          <div className="mb-8" data-id="element-126">
            <div className="flex items-center justify-center gap-2 mb-1" data-id="element-127">
              <span className="text-[#8B7565] text-lg line-through" data-id="element-128">
                $19.99
              </span>
            </div>
            <div className="flex items-baseline justify-center gap-1" data-id="element-129">
              <span className="text-6xl md:text-7xl font-bold text-[#C75B2A]" style={{
              fontFamily: "'DM Serif Display', Georgia, serif"
            }} data-id="element-130">
                $6.39
              </span>
              <span className="text-xl text-[#5C4A3A] font-medium" data-id="element-131">USD</span>
            </div>
            <p className="text-[#8B7565] text-sm mt-2" data-id="element-132">
              Pago único — Sin suscripciones
            </p>
          </div>

          {/* CTA Button */}
          <a href="https://shopcoremethod.com/cart/45996396085445:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-pulse inline-block w-full px-8 py-5 bg-[#C75B2A] hover:bg-[#A84A22] text-white text-lg md:text-xl font-bold rounded-xl transition-colors duration-200 text-center focus:outline-none focus:ring-4 focus:ring-[#C75B2A]/30" data-id="element-133">
            QUIERO RECUPERAR EL CONTROL DE MI HOGAR AHORA
          </a>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6 text-sm text-[#8B7565]" data-id="element-134">
            <div className="flex items-center gap-1.5" data-id="element-135">
              <ZapIcon className="w-4 h-4 text-[#E8A838]" aria-hidden="true" data-id="element-136" />
              <span data-id="element-137">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-138">
              <ShieldCheckIcon className="w-4 h-4 text-[#7B9E6B]" aria-hidden="true" data-id="element-139" />
              <span data-id="element-140">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-141">
              <SmartphoneIcon className="w-4 h-4 text-[#8B7565]" aria-hidden="true" data-id="element-142" />
              <span data-id="element-143">Lee en celular o tablet</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}